// extracted by mini-css-extract-plugin
module.exports = {"editor":"editorStyles_editor__jF8VJ"};